import { ZoomableIframe } from "components/ZoomableIframe"

export const AipIfr = () => (
  <ZoomableIframe src="https://aip.dfs.de/BasicIFR/pages/C00001.html" />
)
